import type React from "react";
import { forwardRef } from "react";
import { Badge } from "../Badge";

export const NeutralBadge = forwardRef(function NeutralBadge(
  { ...props }: React.HTMLAttributes<HTMLSpanElement>,
  ref: React.Ref<HTMLSpanElement>,
) {
  return <Badge variant="neutral" ref={ref} {...props} />;
});

NeutralBadge.displayName = "NeutralBadge";
